module.exports = __webpack_public_path__ + "img/tv_console.bde91e86.png";